const ARABIC_SCRIPT_RE = /[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF]/;

export function isUrduDominant(text) {
  const value = String(text || '').trim();
  if (!value) return true;

  let arabic = 0;
  let latin = 0;

  for (const char of value) {
    if (ARABIC_SCRIPT_RE.test(char)) arabic += 1;
    else if (/[a-zA-Z]/.test(char)) latin += 1;
  }

  return arabic >= latin;
}
